import { DEFAULT_PRO_SUBSCRIBE_OFFER_CODE } from '@components/pages/NewsletterIndexLanding/NewsletterCard/interfaces';
import { newsletter_list_path, subscribe_path, upgrade_subscription_path } from '@routes';

export const handleSubscriberRedirect = ({
  canSubscribeToNewsletter,
  isPro,
  afterSignUpUrl,
  offerCode,
  isCurrentlySubscriber,
  isProSubscriber,
  redirectTo,
}: {
  canSubscribeToNewsletter: boolean;
  isPro: boolean;
  afterSignUpUrl?: string;
  offerCode?: string;
  isCurrentlySubscriber: boolean;
  isProSubscriber: boolean;
  redirectTo?: string;
}) => {
  if (canSubscribeToNewsletter) {
    return afterSignUpUrl || newsletter_list_path();
  }

  if (!isPro) {
    return (
      afterSignUpUrl ||
      subscribe_path({
        offer: offerCode,
        ...(redirectTo && { redirect_to: redirectTo }),
      })
    );
  }

  if (isCurrentlySubscriber && !isProSubscriber) {
    return upgrade_subscription_path();
  }

  return (
    afterSignUpUrl ||
    subscribe_path({
      offer: DEFAULT_PRO_SUBSCRIBE_OFFER_CODE,
      ...(redirectTo && { redirect_to: redirectTo }),
    })
  );
};
